module.exports = __webpack_public_path__ + "img/icon-clipboard.08949509.svg";